import Api from '../http.service';

export const StatusPoints = () =>
  Api.GET({
    url: 'profile_point/status',
  });

/**
 * transfer point
 * @param {Object} payload
 * @param {object} payload.data
 * @param {String} payload.data.pointAmount
 * @param {String} payload.data.secondPassword
 * @param {String} payload.data.recieverProfileId
 * @param {String} payload.data.senderProfileId
 */
export const transferPoint = (payload) =>
  Api.POST({
    url: 'profile_point/transfer',
    data: payload.data,
  });

/**
 * transfer point
 * @param {Object} payload
 * @param {Number} payload.profileId
 * @param {Number} payload.pageNumber
 * @param {Number} payload.itemPerPage
 * @param {object} payload.data
 * @param {object} payload.data.sort
 * @param {String} payload.data.sort.createdAt
 * @param {Object} payload.data.filter
 * @param {String} payload.data.filter.point
 * @param {Number} payload.data.filter.id
 * @param {String} payload.data.filter.subjectId
 * @param {String} payload.data.filter.startDate
 * @param {String} payload.data.filter.endDate
 *
 */
export const allPoint = (payload) =>
  Api.POST({
    url: `profile_point/profile_all/${payload.profileId}/${
      payload.pageNumber - 1
    }/${payload.itemPerPage}`,
    data: payload.data,
  });
